
define('generic/xhr',["require", "exports", '../core/util', '../core/buffer', '../core/api_error'], function(require, exports, util, buffer, api_error) {
    var ApiError = api_error.ApiError;
    var ErrorCode = api_error.ErrorCode;
    var Buffer = buffer.Buffer;

    

    function getIEByteArray(IEByteArray) {
        var rawBytes = IEBinaryToArray_ByteStr(IEByteArray);
        var lastChr = IEBinaryToArray_ByteStr_Last(IEByteArray);
        var data_str = rawBytes.replace(/[\s\S]/g, function (match) {
            var v = match.charCodeAt(0);
            return String.fromCharCode(v & 0xff, v >> 8);
        }) + lastChr;
        var data_array = new Array(data_str.length);
        for (var i = 0; i < data_str.length; i++) {
            data_array[i] = data_str.charCodeAt(i);
        }
        return data_array;
    }

    function downloadFileIE(async, p, type, cb) {
        switch (type) {
            case 'buffer':

            case 'json':
                break;
            default:
                return cb(new ApiError(9 /* EINVAL */, "Invalid download type: " + type));
        }

        var req = new XMLHttpRequest();
        req.open('GET', p, async);
        req.setRequestHeader("Accept-Charset", "x-user-defined");
        req.onreadystatechange = function (e) {
            var data_array;
            if (req.readyState === 4) {
                if (req.status === 200) {
                    switch (type) {
                        case 'buffer':
                            data_array = getIEByteArray(req.responseBody);
                            return cb(null, new Buffer(data_array));
                        case 'json':
                            return cb(null, JSON.parse(req.responseText));
                    }
                } else {
                    return cb(new ApiError(req.status, "XHR error."));
                }
            }
        };
        req.send();
    }

    function asyncDownloadFileIE(p, type, cb) {
        downloadFileIE(true, p, type, cb);
    }

    function syncDownloadFileIE(p, type) {
        var rv;
        downloadFileIE(false, p, type, function (err, data) {
            if (err)
                throw err;
            rv = data;
        });
        return rv;
    }

    function asyncDownloadFileModern(p, type, cb) {
        var req = new XMLHttpRequest();
        req.open('GET', p, true);
        var jsonSupported = true;
        switch (type) {
            case 'buffer':
                req.responseType = 'arraybuffer';
                break;
            case 'json':
                try  {
                    req.responseType = 'json';
                    jsonSupported = req.responseType === 'json';
                } catch (e) {
                    jsonSupported = false;
                }
                break;
            default:
                return cb(new ApiError(9 /* EINVAL */, "Invalid download type: " + type));
        }
        req.onreadystatechange = function (e) {
            if (req.readyState === 4) {
                if (req.status === 200) {
                    switch (type) {
                        case 'buffer':
                            return cb(null, new Buffer(req.response ? req.response : 0));
                        case 'json':
                            if (jsonSupported) {
                                return cb(null, req.response);
                            } else {
                                return cb(null, JSON.parse(req.responseText));
                            }
                    }
                } else {
                    return cb(new ApiError(req.status, "XHR error."));
                }
            }
        };
        req.send();
    }

    function syncDownloadFileModern(p, type) {
        var req = new XMLHttpRequest();
        req.open('GET', p, false);

        var data = null;
        var err = null;

        req.overrideMimeType('text/plain; charset=x-user-defined');
        req.onreadystatechange = function (e) {
            if (req.readyState === 4) {
                if (req.status === 200) {
                    switch (type) {
                        case 'buffer':
                            var text = req.responseText;
                            data = new Buffer(text.length);

                            for (var i = 0; i < text.length; i++) {
                                data.writeUInt8(text.charCodeAt(i), i);
                            }
                            return;
                        case 'json':
                            data = JSON.parse(req.responseText);
                            return;
                    }
                } else {
                    err = new ApiError(req.status, "XHR error.");
                    return;
                }
            }
        };
        req.send();
        if (err) {
            throw err;
        }
        return data;
    }

    

    function syncDownloadFileIE10(p, type) {
        var req = new XMLHttpRequest();
        req.open('GET', p, false);
        switch (type) {
            case 'buffer':
                req.responseType = 'arraybuffer';
                break;
            case 'json':
                break;
            default:
                throw new ApiError(9 /* EINVAL */, "Invalid download type: " + type);
        }
        var data;
        var err;
        req.onreadystatechange = function (e) {
            if (req.readyState === 4) {
                if (req.status === 200) {
                    switch (type) {
                        case 'buffer':
                            data = new Buffer(req.response);
                            break;
                        case 'json':
                            data = JSON.parse(req.response);
                            break;
                    }
                } else {
                    err = new ApiError(req.status, "XHR error.");
                }
            }
        };
        req.send();
        if (err) {
            throw err;
        }
        return data;
    }

    function getFileSize(async, p, cb) {
        var req = new XMLHttpRequest();
        req.open('HEAD', p, async);
        req.onreadystatechange = function (e) {
            if (req.readyState === 4) {
                if (req.status == 200) {
                    try  {
                        return cb(null, parseInt(req.getResponseHeader('Content-Length'), 10));
                    } catch (e) {
                        return cb(new ApiError(2 /* EIO */, "XHR HEAD error: Could not read content-length."));
                    }
                } else {
                    return cb(new ApiError(req.status, "XHR HEAD error."));
                }
            }
        };
        req.send();
    }

    exports.asyncDownloadFile = (util.isIE && typeof Blob === 'undefined') ? asyncDownloadFileIE : asyncDownloadFileModern;

    exports.syncDownloadFile = (util.isIE && typeof Blob === 'undefined') ? syncDownloadFileIE : (util.isIE && typeof Blob !== 'undefined') ? syncDownloadFileIE10 : syncDownloadFileModern;

    function getFileSizeSync(p) {
        var rv;
        getFileSize(false, p, function (err, size) {
            if (err) {
                throw err;
            }
            rv = size;
        });
        return rv;
    }
    exports.getFileSizeSync = getFileSizeSync;

    function getFileSizeAsync(p, cb) {
        getFileSize(true, p, cb);
    }
    exports.getFileSizeAsync = getFileSizeAsync;
});
//# sourceMappingURL=xhr.js.map
;